import AddNewBrochureModal from "./AddNewBrochureModal.component";

export default AddNewBrochureModal;
